// extracted by mini-css-extract-plugin
export default {"PostMenu":"styles_PostMenu__oLHf3","dotsButton":"styles_dotsButton__riU73"};